const STEPS = ['termo', 'anexos', 'ia', 'espera'];

const LiveKitStepper = ({ activeStep }) => {
	const activeIndex = Math.max(0, STEPS.indexOf(activeStep));
	const progress = ((activeIndex + 1) / STEPS.length) * 100;

	return (
		<div className="lk-progress-bar">
			<div className="lk-progress-bar__fill" style={{ width: `${progress}%` }} />
		</div>
	);
};

export default LiveKitStepper;
